import { render, staticRenderFns } from "./NicheNewList.vue?vue&type=template&id=b26c3e00&scoped=true"
import script from "./NicheNewList.vue?vue&type=script&lang=js"
export * from "./NicheNewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26c3e00",
  null
  
)

export default component.exports